export default {
      id: "contacts-line-usage",
      viewBox: "0 0 146 47",
      url: __webpack_public_path__ + "img/icons.8611a534.svg#contacts-line",
      toString: function () {
        return this.url;
      }
    }